import React, { Component } from 'react';
import { formatCurrency } from '@C/TableGrid';
import { ReceiptText } from 'lucide-react';

export class ProductSalesSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header>
            <ReceiptText color="#31af36" />
            <h3>Product Sales Summary</h3>
          </header>
          <main className="content-wrapper">
            <table className="dsr" data-name="Product Sales">
              <tbody>
                {summary.map((item, i) => (
                  <tr key={i}>
                    <td>Total {item.product} sales </td>
                    <td>
                      {`${item.product == 'lube' ? 'Qty' : 'Litres'}`}:{' '}
                      {item.total_sale_in_liters.toFixed(2)}
                    </td>
                    <td>{formatCurrency(item.total_sale_value || 0)} </td>
                  </tr>
                ))}
                {/* <tr className="summary-row">
                  <td colSpan="2">Total litres sold </td>
                  <td className="">
                    {summary.reduce(
                      (a, b) => a + (b['total_sale_in_liters'] || 0),
                      0,
                    ).toFixed(2) || 0.00}
                  </td>
                </tr> */}
                <tr className="summary-row">
                  <td colSpan="2">Total sale amount </td>
                  <td>
                    {' '}
                    {formatCurrency(
                      summary.reduce(
                        (a, b) => a + (b['total_sale_value'] || 0),
                        0,
                      ) || 0,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
